import DescForm from './component'

export default DescForm
